import React, { useState } from "react"
import { Button, Col, Modal, Row } from "react-bootstrap"
import videos from "./Tutoriales/Videos"
import IconoAyuda from "./Utils/IconoAyuda"
import tutoriales from "./Tutoriales/Tutoriales"

const Ayuda = (props) => {
  const [showModal, setShowModal] = useState(false)
  const [openVideo, setOpenVideo] = useState(null)

  const toggle = () => {
    setShowModal((previous) => {
      return !previous
    })
  }

  return (
    <>
      <h4>
        <IconoAyuda background={true} /> Ayuda
      </h4>
      <Row>
        <Col xs={12} md={6}>
          <h5>Videos demostrativos</h5>
          <ul>
            {videos.map((video, idx) => {
              return (
                <li key={idx}>
                  <div
                    role="button"
                    onClick={() => {
                      setOpenVideo(idx)
                      setShowModal(true)
                    }}
                  >
                    {video.title}
                  </div>
                </li>
              )
            })}
          </ul>
        </Col>
      </Row>
      {openVideo !== null && (
        <Modal show={showModal} onHide={toggle} className="video-modal">
          <Modal.Header toggle={toggle}>{videos[openVideo].title}</Modal.Header>
          <Modal.Body>
            {videos[openVideo].description}
            <video
              playsInline={true}
              autoPlay="autoplay"
              muted
              id={"bgvid" + openVideo}
              key={openVideo}
            >
              <source src={videos[openVideo].video} type="video/mp4" />
            </video>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={toggle}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Row>
        <Col xs={12}>
          <h5>Tutoriales interactivos</h5>
        </Col>
      </Row>
      <Row>
        {Object.values(tutoriales).map((tutorial, idx) => {
          return (
            <Col
              onClick={() => {
                if (props.setOpenTour) {
                  props.setOpenTour("barra")
                }
              }}
            >
              {Object.values}
              Barra de navegación
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default Ayuda
